import { render, staticRenderFns } from "./FooterToolBar.vue?vue&type=template&id=56527af4&scoped=true"
import script from "./FooterToolBar.vue?vue&type=script&lang=js"
export * from "./FooterToolBar.vue?vue&type=script&lang=js"
import style0 from "./FooterToolBar.vue?vue&type=style&index=0&id=56527af4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56527af4",
  null
  
)

export default component.exports